import React, { useEffect } from 'react';
import '../styles/TermsConditions.css';

const TermsConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <section className="terms-conditions-page">
      <div className="terms-conditions-header">
        <h1 className="terms-conditions-title">
          <span className="highlight">Terms</span> and <span className="highlight">Conditions</span>
        </h1>
        <p className="terms-conditions-update-date">Last Updated: 08/04/2025</p>
      </div>

      <div className="terms-conditions-content">
        <p>
          Welcome to Mahadev Book Official. By accessing and using our platform, you agree to comply with the terms and conditions outlined below. Please read this document carefully to understand your rights and obligations while using our services.
        </p>

        <p><strong>1. Acceptance of Terms:</strong> By using Mahadev Book Official, you agree to these terms. If you do not agree, please do not use our platform.</p>

        <p><strong>2. User Registration:</strong> Certain features require registration. Keep your credentials secure and do not share them with others.</p>

        <p><strong>3. Age Restrictions:</strong> You must be of legal gambling age in your region to use our platform. By registering, you confirm that you meet the legal age requirements.</p>

        <p><strong>4. Responsible Gaming:</strong> We support responsible gaming. If you feel you may be developing a gambling issue, please seek help. Self-exclusion tools are available.</p>

        <p><strong>5. Intellectual Property:</strong> All content on Mahadev Book Official is protected by copyright. Do not use or redistribute without permission.</p>

        <p><strong>6. Financial Transactions:</strong> All payments must comply with applicable laws. We use secure systems for all financial operations. Fraud will lead to account suspension and legal consequences.</p>

        <p><strong>7. Platform Usage:</strong> Do not use bots, hack, or interfere with the platform's operations. Misuse may lead to a permanent ban.</p>

        <p><strong>8. Termination of Account:</strong> We reserve the right to terminate accounts for violations of our terms.</p>

        <p><strong>9. Changes to Terms:</strong> We may update terms at any time. Continued use of the platform after changes indicates your acceptance.</p>

        <p>
          <strong>10. Contact Information:</strong> For any queries, contact us via WhatsApp at{' '}
          <a href={ContactLink} target="_blank" rel="noopener noreferrer">+91 8888568888</a>.
        </p>

        <p style={{ color: "#DAA520" }}>
          Thank you for choosing Mahadev Book Official. We’re committed to offering you a safe, secure, and enjoyable gaming experience.
        </p>
      </div>

      <div className="terms-btn">
        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 8888568888
        </a>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          WhatsApp Us @ 8888988880
        </a>
      </div>
    </section>
  );
};

export default TermsConditions;
